<template>
    <div class="row">
        <div class="mission-container">
            <p class="caption">Onze Missie</p>
            <div class="fictional-client-mission">
                <div class="fictional-client-container">
                    <p class="future-heading">1</p>
                    <p class="fictional-client-text">Bij LeefGoed zetten we ons dagelijks in voor een thuis voor iedereen.
                        Wij geloven dat goed wonen de basis is voor een goed leven. <b>Betaalbare woningen, veilige
                        buurten en duurzame leefomgevingen</b> &ndash; dat is waar wij elke dag aan werken.</p>
                </div>
                <div class="journey-guide">
                    <p class="big-heading">2</p>
                    <p class="journey-guide1">Wij luisteren naar onze huurders en werken nauw samen met gemeenten
                        en zorgpartners. <b>Wij nemen samenwerking serieus</b> &ndash; ook
                        wanneer dat moeilijke keuzes vraagt. Samen bouwen we aan sterke wijken
                        en een leefbare regio.
                    </p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'HomeBlockMission'
};
</script>

<style scoped>
.mission-container {
    box-sizing: border-box;
    max-width: 73.125rem;
    background: white;
}

.fictional-client-mission {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 3.75rem;
}

.fictional-client-container {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}

.future-heading {
    box-sizing: border-box;
    flex: 0 0 auto;
    margin-top: -2.8rem;
    /* padding-bottom: 4.5rem; */
    font: 900 12.5rem Roboto;
    color: var(--color-primary-alpha);
}

.journey-guide {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 2.9375rem;
    margin-bottom: -1rem;
}

.big-heading {
    box-sizing: border-box;
    flex: 0 0 auto;
    /* padding-bottom: 0.625rem; */
    font: 900 12.5rem Roboto;
    color: var(--color-primary-alpha);
    margin-bottom: -1rem;
}

.fictional-client-text {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: 1.875rem;
}

.journey-guide1 {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: -1.1875rem;
}

.signature {
    font-size: 15pt;
    display: block;
    margin-top: 2rem;
}
</style>
